import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex h-screen flex-col items-center justify-center px-4 text-center">
      <div className="pointer-events-none absolute bottom-0 z-0 select-none text-9xl font-black text-foreground-100 md:text-[12rem]">
        404
      </div>
      <div className="relative z-10">
        <h1 className="mt-6 text-xl font-semibold text-foreground-950 md:text-2xl">
          Trang này chưa được tạo
        </h1>
        <p className="mt-2 text-base text-foreground-400">
          {location.pathname}
        </p>
        <p className="mt-4 text-lg text-foreground-500 md:text-xl">
          Mô tả thêm về trang này để mình tạo giúp bạn nhé
        </p>
      </div>
    </div>
  );
}